import { render, staticRenderFns } from "./TransactionIndex.vue?vue&type=template&id=d49597b4"
import script from "./TransactionIndex.vue?vue&type=script&lang=js"
export * from "./TransactionIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports